<div class="row">
    <div class="col-12">
        <form [formGroup]="model.asForm" (ngSubmit)="enviar()">
            <div class="">
                <span class="text-black">Para prosseguirmos com a proposta, é necessário informações iniciais do
                    credor</span>
            </div>
            <div class="form-group mb-3 mt-3">
                <label for="nomeCredor"> Profissão </label>
                <input type="text"
                    [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.profissao.invalid}"
                    class="form-control" id="profissao" placeholder="Ex: Aposentado" formControlName="profissao">
                <div class="invalid-feedback">
                    <span>Campo obrigatório</span>
                </div>
            </div>
            <div class="form-group mb-3">
                <label for="telefoneCredor">Telefone</label>
                <input type="text" class="form-control" [mask]="'(00) 0 0000-0000||(00) 0000-0000'" id="telefoneCredor"
                    [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.telefoneCredor.invalid}"
                    aria-describedby="telefoneCredor" placeholder="Ex: (00) 00000-0000"
                    formControlName="telefoneCredor">
                <div class="invalid-feedback">
                    <span>Campo obrigatório</span>
                </div>
            </div>
            <div class="form-group mb-3">
              <label for="emailCredor">E-mail</label>
              <input type="text" class="form-control" id="emailCredor"
                     [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.emailCredor.invalid}"
                     aria-describedby="emailCredor" placeholder="Ex: credor@email.com"  formControlName="emailCredor">
              <div class="invalid-feedback">
                <span>Campo obrigatório</span>
              </div>
            </div>
            <div class="form-group mb-3">
                <app-input-text-area
                    [label]="'Observações'"
                    [id]="'observacao'"
                    [rows]="3"
                    [required]="false"
                    [maxlength]="LIMITES_CARACTERES.OBSERVACAO"
                    [invalid]="!validarFormulario && model.form.controls.observacaoCredor.invalid"
                    [msgAlerta]="'Limite máximo de caracteres: ' + LIMITES_CARACTERES.OBSERVACAO"
                    formControlName="observacaoCredor"></app-input-text-area>
            </div>
        </form>
    </div>
</div>

<div class="row mt-3">
    <div class="col-6">
        <button class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()"> Voltar </button>
    </div>
    <div class="col-6">
        <button (click)="enviar()" class="btn btn-primary float-end btn-sm w-100"> Aceitar proposta </button>
    </div>
</div>
